import React, { useState } from "react";
import {
	Dialog,
	DialogTitle,
	DialogContent,
	DialogContentText,
	DialogActions,
	Button,
	FormControl,
	InputLabel,
	Select,
	MenuItem,
} from "@mui/material";

export interface SampleIdPropertyDialogProps {
	open: boolean;
	propertyKeys: string[];
	onConfirm: (key: string) => void;
	onSkip: () => void;
}

/**
 * Dialog shown when a points file upload has no auto-detectable sample_id property.
 * Lets the user pick which property to use, or skip to auto-generate numeric IDs.
 */
export const SampleIdPropertyDialog: React.FC<SampleIdPropertyDialogProps> = ({
	open,
	propertyKeys,
	onConfirm,
	onSkip,
}) => {
	const [selectedKey, setSelectedKey] = useState("");

	return (
		<Dialog open={open} onClose={onSkip} maxWidth="sm" fullWidth>
			<DialogTitle>Select Sample ID Property</DialogTitle>
			<DialogContent>
				<DialogContentText sx={{ mb: 2 }}>
					Could not auto-detect which property contains sample IDs. Select the correct property, or skip to
					auto-generate numeric IDs.
				</DialogContentText>
				<FormControl fullWidth size="small">
					<InputLabel>Property</InputLabel>
					<Select value={selectedKey} label="Property" onChange={(e) => setSelectedKey(e.target.value)}>
						{propertyKeys.map((key) => (
							<MenuItem key={key} value={key}>
								{key}
							</MenuItem>
						))}
					</Select>
				</FormControl>
			</DialogContent>
			<DialogActions>
				<Button onClick={onSkip}>Skip (auto-generate)</Button>
				<Button onClick={() => onConfirm(selectedKey)} disabled={!selectedKey} variant="contained">
					Use Selected
				</Button>
			</DialogActions>
		</Dialog>
	);
};
